import React, {Component, Fragment} from 'react';
import PropTypes from  'prop-types';
import  { withStyles } from  '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import FormGroup from '@material-ui/core/FormGroup';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';


function jsUcfirst(string) 
{
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function Transition(props) {
    return <Slide direction="up" {...props} />;
  }

const styles = theme => ({
  root: {
    flexGrow: 1, 
    minHeight: 400,
    margin: theme.spacing.unit * 2,
  },
  title: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit
  },
  description:{
    color:'#45A29E'
  },
  divider:{
    marginTop: theme.spacing.unit * 1,
    marginBottom: theme.spacing.unit * 1,
  },
  divider2:{
    marginTop: theme.spacing.unit * 2,
    marginBottom: theme.spacing.unit * 1,
  },
  card:{
    width: 300,
    height: 200,
    margin: theme.spacing.unit * 2,
  },
  cardSelected: {
    width: 300,
    height: 200,
    margin: theme.spacing.unit * 2,
    color:'#1F2833',
    backgroundColor: theme.palette.primary.main, //green[500],
    '&:hover': {
      backgroundColor: theme.palette.primary.main,//green[700],
    }
  },
  
});




const verbiage = {
    campaigns:{
        carte:{
            title:'Tiered Pricing',
            description:'Value-based, incremental pricing levels.',
            info:'Tiered pricing is meant to offer proper market value for each lead that is sold. There are a variety of lead specifications that factor in to our assessment of value (more in Lead Info tab), and our pricing levels are categorized by federal poverty level which is a great indicator of a lead prospect’s household purchasing power.'
        },
        fixed:{
            title:'Special Offers',
            description:'Specific keyword filtering & combo deals.',
            info:'Leads from our specific keyword filters and combo deals are sold for a fixed price and are delivered based on our current lead flow & buyer activity. We refer to combo leads as a ‘mixed bag’ of leads because you will receive a random assortment of lead types, meaning you could benefit from certain lead types being offered at a discount at any give time.'
        },
        company:{
            title:'Company Bucket',
            description:'Your company offers ...',
            info:'More info here'
        }
    },
    leads:{
        exclusive:{
            title:'Exclusive',
            description:'Sold exclusively to 1 individual buyer.',
            info:'Delivered with opt-in interest and in real-time to the lead destination that is specified by an exclusive purchaser’s active lead campaign.'
        },
        shared:{
            title:'Shared',
            description:'First-come-first-serve to < 5 buyers.',
            info:'Any shared leads that we sell are generated using strategies & ad channels that are completely separate from our exclusive lead acquisition. Our routing system still ensures randomized distribution for shared leads, and we never deliver unique lead information to agents working within the same network or to more than 5 different networks.'
        },
        recycled:{
            title:'Recycled',
            description:'Redistributed from qualified networks.',
            info:'Recycled leads are leads that have had their contact information already verified but that did not qualify when speaking with another agent outside of your network. Also known as DNQs, this type of lead is sold exclusively to you as the new agent.'
        }
    }

}

@inject("commonStore")
@observer
class CampaignType extends Component {
    state = {
        open: false,
    };

    handleClickOpen = (info) => {
    this.setState({ open: true, ...info });
    };

    handleClose = () => {
    this.setState({ open: false });
    };
    
  makeInfoDialog = () => {
    const { open, title, info } = this.state
   return  <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={this.handleClose}
    aria-labelledby="alert-dialog-slide-title"
    aria-describedby="alert-dialog-slide-description"
  >
    <DialogTitle id="alert-dialog-slide-title">
      {title ? title : ''}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-slide-description">
        {info}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={this.handleClose} color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>

  }
  handleLanguageChange = (event) => {
    const { handleUpdate } = this.props
    const { target: {value}} = event
 
    if(value === 'spanish'){
      handleUpdate('allowEnglish', false)
      handleUpdate('allowSpanish', true)
    }else if(value === 'english'){
      handleUpdate('allowSpanish', false)
      handleUpdate('allowEnglish', true)
    }else{
      handleUpdate('allowSpanish', true)
      handleUpdate('allowEnglish', true)
    }
  }
  makeLanguageOptions = () => {
    const { allowEnglish, allowSpanish } = this.props 

    console.log('allowEnglish')
    console.log(allowEnglish)

    console.log('allowSpanish')
    console.log(allowSpanish)

    let selection = 'english'
    if(allowEnglish && allowSpanish){
      selection = ' bilingual'
    }else if (allowSpanish){
      selection = 'spanish'
    }

    console.log('selection')
    console.log(selection)

    return (
        <div>
        <FormLabel component="legend">Language Options</FormLabel>
        <RadioGroup aria-label="position" name="position" value={selection} onChange={this.handleLanguageChange} row>
        <FormControlLabel
            value="english"
            control={<Radio color="primary" />}
            label="English"
            labelPlacement="end"
          />
          <FormControlLabel
            value="spanish"
            control={<Radio color="primary" />}
            label="Spanish"
            labelPlacement="end"
          />
          <FormControlLabel
            value="bilingual"
            control={<Radio color="primary" />}
            label="Bilingual"
            labelPlacement="end"
          />
        </RadioGroup>
        </div>
 
    );
  }
  makeCampaignTypeCards = () => {
        const { classes, commonStore, updateCampaignType, priceMapType } = this.props
        const { network } = commonStore
        const { priceMaps } = network
        console.log( this.props)
        const types = Object.keys(priceMaps)
        console.log(types)
        return types.map(type => {
            const { title, description, info } = verbiage['campaigns'][type]
            return  <Card key={type} className={priceMapType === type ? classes.cardSelected : classes.card }>
            <CardContent>
            <Switch
            onChange={() => updateCampaignType(type)}
            checked={priceMapType === type}
          />
              <Typography color={'inherit'} variant="h5" component="h2">
                {title}
              </Typography>
              <div className={classes.divider }>
                <Divider color={'inherit'} />
              </div>
              <Typography color={'inherit'} component="p">
                {description}
              </Typography>
            </CardContent>
            <CardActions>
            <div className={classes.description }>
              <Button size="small" color={'inherit'} onClick={() => this.handleClickOpen({title, info})}>Learn More</Button>
              </div>
            </CardActions>
          </Card>
        })

  }
  makeLeadTypeCards = () => {
    const { classes, commonStore, updateLeadType, leadType, priceMapType } = this.props
    const { network } = commonStore
    const { types } = network
    const { leadTypes: allowedTypes } = types
    console.log(allowedTypes)
    return allowedTypes.map(type => {
        
        const { title, description, info } = verbiage['leads'][type]

        return (
        <Card key={type} className={leadType === type ? classes.cardSelected : classes.card }>
        <CardContent>
        <Switch
        disabled={priceMapType !== 'carte'}
        onChange={() => {updateLeadType(type)}}
        checked={leadType === type}
      />
          <Typography variant="h5" color={'inherit'}>
            {title}

          </Typography>
          <div className={classes.divider }>
          
          <Divider color={'inherit'} />
          </div>
          <Typography color={'inherit'} component="p">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
        <div className={classes.description }>
          <Button  color={'inherit'} size="small" onClick={() => this.handleClickOpen({title, info})}>Learn More</Button>
          </div>
        </CardActions>
      </Card>)
    })

}
  render() {
 
    const { classes, priceMapType } = this.props;

    return (
         <div className={classes.rot}>
         <Typography className={classes.title} variant="h5"> Select Your Campaign Type</Typography>
         <Divider className={classes.divider2} />
         {this.makeLanguageOptions()}
         <Grid
         container
         alignItems={'center'}
         direction={'row'}
         justify={'flex-start'}
       >{this.makeCampaignTypeCards()}</Grid>

            <Typography className={classes.title} variant="h5"> Select Your Lead Type</Typography>
            <div className={classes.description }>
            <Typography color={'inherit'}>
              (Only Available for Tiered Pricing)
            </Typography>
            </div>
            <Grid
            container
            alignItems={'center'}
            direction={'row'}
            justify={'flex-start'}
            >
            {this.makeLeadTypeCards()}
            </Grid>
            {this.makeInfoDialog()}
      </div>
    );
  }
}

CampaignType.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CampaignType);


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/Options/CampaignType.js